import { useForm } from "@refinedev/react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

import { storeSchema, StoreFormValues } from "@modules/stores/validations/storeSchema";
import { useCreateStoreMutation } from "@modules/stores/services/mutations";

export function useStoreCreateForm() {
  const { mutateAsync, isPending } = useCreateStoreMutation();

  const methods = useForm<StoreFormValues>({
    resolver: zodResolver(storeSchema()),
    defaultValues: {
      country: "Brasil",
      active: true,
    },
    mode: "onBlur",
  });

  const {
    handleSubmit,
  } = methods;

  return {
    methods,
    isPending,
    handleSubmit,
    mutateAsync,
  };
}
